import React from 'react';
import { useDispatch} from 'react-redux';
import { uiOpenModal } from '../../actions/ui';
import './btn.css';

export const ImportBtn = () => {

    const dispatch = useDispatch()

    const handleImport = () => {
        dispatch(uiOpenModal());
    }

    return (
        <button className="btn btn-danger margin_right_envelope btnColor" onClick={handleImport}>
            <i className="fas fa-user-alt icon"> </i>
            <span className="navbar-brand user">
                IMPORTAR STOCK
            </span>
        </button>
    )
}